import { Auth, User, Config, Shares } from '@ciitizen/api'
import decode from 'jwt-decode'
import { onboardingUrl } from 'config'

const state = {
  authData: {},
  userId: '',
  share: {},
  DocumentOnly: false,
  fullProfile: false,
  CancerSummary: false,
  ImagingStudy: false
}

const actions = {
  async login({ commit }, { username, password }) {
    try {
      const data = await Auth.login({ username: username.toLowerCase(), password })
      commit('SET_AUTH_DATA', data.items)
      commit('SET_USER_ID', data)
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  },
  // call to the new endpoint to create user and assign tasks
  async createUser({ commit }, payload) {
    try {
      const data = await User.createUser(payload)
      commit('SET_AUTH_DATA', data.items)
      commit('SET_USER_ID', data)
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  },
  async registerUser(store, payload) {
    try {
      const data = await User.registerUser(payload)
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  },

  async updateUserProfile(store, { uuid, ...payload }) {
    try {
      const data = await User.updateUserProfile(uuid, payload)
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  },
  async createCaregiverPatient(store, { uuid, ...payload }) {
    try {
      const data = await User.createCaregiverPatient(uuid, payload)
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  },
  async resetPassword({ commit }, payload) {
    try {
      return await Auth.resetPassword(payload)
    } catch (err) {
      console.error(err)
      throw err
    }
  },
  authenticateUser({ commit }, payload) {
    try {
      localStorage.setItem('default_auth_token', payload.id_token)
      commit('SET_USER_ID', payload)
    } catch (err) {
      console.error(err)
      throw err
    }
  },
  async fetchOnboardingSession({ commit }, uuid) {
    try {
      return await User.getOnboardingSession({ uuid })
    } catch (err) {
      console.error(err)
      throw err
    }
  },
  resumeOnboarding({ commit }, payload) {
    const { userSession } = payload
    const { state } = userSession
    const { meta, provider } = state
    if (meta && meta.user_tags && meta.user_tags.includes('from_hie')) {
      window.location.replace(`${onboardingUrl}/hie/${provider}?session_tkn=${localStorage.getItem(
        'default_auth_token'
      )}
      `)
    } else {
      window.location.replace(`${onboardingUrl}?session_tkn=${localStorage.getItem(
        'default_auth_token'
      )}
      `)
    }
  },
  async shareDetailWithIdAndToken({ commit }, payload) {
    try {
      const resp = await Shares.shareDetailWithIdAndToken(payload)
      const { sharingResources = [] } = resp
      let scope = 'documents'
      const today = new Date()
      for (const sharingResource of sharingResources) {
        const { resourceType = null, expiry = null } = sharingResource
        const type = resourceType.toLowerCase()
        if (type === '*' && (!expiry || (expiry && Date.parse(expiry) > today))) {
          scope = 'documents'
          localStorage.setItem('shareType', '*')
          state.fullProfile = true
          // break
        } else if (type === 'document' && (!expiry || (expiry && Date.parse(expiry) > today))) {
          scope = 'documents'
          localStorage.setItem('shareType', 'documents')
          state.DocumentOnly = true
          // break
        } else if (type === 'imagingstudy' && (!expiry || (expiry && Date.parse(expiry) > today))) {
          scope = 'ImagingStudy'
          localStorage.setItem('shareType', 'ImagingStudy')
          state.ImagingStudy = true
          // break
        } else if (type === 'cc' || type === 'vmtb') {
          scope = type
          state.CancerSummary = true
          localStorage.setItem('shareType', 'cc')
          // break
        } else {
          scope = 'expired'
        }
      }
      commit('SET_DOCUMENT_SHARE', { resp, scope })
    } catch (err) {
      console.error(err)
      state.share = null
    }
  },
  async redirectToOnboarding(store, { url, token, type }) {
    window.location.href = `${url}?tkn=${token}&register-type=${type}`
  }
}

const mutations = {
  SET_AUTH_DATA(state, payload) {
    state.authData = payload
  },
  SET_USER_ID(state, payload) {
    const decodedToken = payload.id_token ? decode(payload.id_token) : decode(payload.idToken)
    state.userId = decodedToken['https://ctz.nz/id']
  },
  SET_DOCUMENT_SHARE(state, payload) {
    state.share = payload.resp
    state.share.scope = payload.scope
  }
}

export default {
  state,
  actions,
  mutations
}
